import { render, staticRenderFns } from "./userMgr.vue?vue&type=template&id=1035b873&"
import script from "./userMgr.vue?vue&type=script&lang=js&"
export * from "./userMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports